
import { Component, Prop, Vue,Watch } from "vue-property-decorator";

@Component
export default class HorizontalScrollList extends Vue {
  @Prop({ required: true }) private items!: any[];
  @Prop({ required: false }) private nItems?: number;
  @Prop({ required: false, default: () => ({}) }) private bannerListStyle!: object;
  @Prop({ required: false, default: false }) private centerFirstCard?: boolean;
  @Prop({ required: false, default:true }) private showScrollMobile?: boolean;

  private currentIndex: number = 0;
  windowWidth: number = window.innerWidth;

  private get isMobile() {
    return this.windowWidth < 768;
  }

  private get itemsToShow() {
    return this.nItems && this.items ? this.items.slice(0, this.nItems) : this.items;
  }

  @Watch('items', { immediate: true, deep: true })
  onItemsChanged() {
    this.$nextTick(() => {
      this.checkSizes();
    });
  }

  async mounted() {
    window.addEventListener("resize", this.checkSizes);
  }

  protected beforeDestroy() {
    window.removeEventListener("resize", this.checkSizes);
  }

  private checkSizes(){
    this.handleResize();
    this.checkScroll();
    if(this.isMobile && this.centerFirstCard){
      this.adjustPadding();
    }
  }

  private handleResize() {
    this.windowWidth = window.innerWidth;
  }


  private handleScroll(event: Event) {
    const container = event.target as HTMLElement;
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth - container.clientWidth;

    const totalCards = this.items.length;

    if (scrollWidth === 0) {
      this.currentIndex = 0;
      return;
    }

    const percent = scrollLeft / scrollWidth;
    this.currentIndex = Math.round(percent * (totalCards - 1));
  }

  private scrollToCard(index: number) {
    const container = this.$refs.bannerList as HTMLElement;
    const card = container.children[index] as HTMLElement;

    if (card && container) {
      container.scrollTo({
        left: card.offsetLeft,
        behavior: "smooth",
      });
    }
  }

  private checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs.bannerContainer as HTMLElement | null;
      const list = this.$refs.bannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;
        list.style.justifyContent = hasHorizontalScroll
          ? "flex-start"
          : "center"; 
      }
    });
  }

  private adjustPadding(retryCount = 3) {
    this.$nextTick(() => {
      const container = this.$refs.bannerContainer as HTMLElement;
      const list = this.$refs.bannerList as HTMLElement;
      const card = list?.children[0] as HTMLElement;

      if (container && list && card && card.offsetWidth > 0) {
        const containerWidth = container.clientWidth;
        const cardWidth = card.offsetWidth;
        const sidePadding = (containerWidth - cardWidth) / 2;

        list.style.paddingLeft = `${sidePadding}px`;
        list.style.paddingRight = `${sidePadding}px`;
      } else if (retryCount > 0) {
        setTimeout(() => this.adjustPadding(retryCount - 1), 100);
      }
    });
  }
}
